const sentryIgnoreErrors: (RegExp | string)[] = [
  /Load failed/i,
  /Event `CustomEvent`/i,
  /Network Error/i,
  /The quota has been exceeded./i,
  /Unexpected token '<'/i,
];

export default sentryIgnoreErrors;
